import React, { useState, useEffect } from 'react';

import {
  Menu,
  //Button,
  Dropdown,
  //Flag,
} from 'semantic-ui-react';

export default function NavItemLanguageSelect(props) {
  //console.log('NavItemLanguageSelect - props', props);
  const parsedProps = JSON.parse(JSON.stringify(props))
  // gatsby needs help for some reason
  /* const parsedProps = JSON.parse(JSON.stringify(props))
  for (let contentItem of parsedProps.bag.contentItems) {
    delete contentItem.navItems
  } */
  //const textColor = props.textColor ? props.textColor : props.header_text_color ? props.header_text_color : null;

  const determineSubDomain = () => {
    const host = window.location.host;
    const subdomain = host.split('.')[0];
    return { host, subdomain }
  }
  let defaultLanguage = {
    key: 'english', 
    text: 'English', 
    value: 'en-US', 
    flag: 'us'
  };

  const [initLanguage, setInitLanguage] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(defaultLanguage);

  useEffect(() => {
    if (typeof window !== 'undefined' || initLanguage === false) {
      //const subdomain = 'es';
      const subdomain = determineSubDomain().subdomain;
      //console.debug('NavItemLanguageSelect - subdomain', subdomain);
      if (subdomain === 'fr' || subdomain === 'es') {
        const locatedSelectedLanuage = props.bag.contentItems.filter(navItem => navItem.value === subdomain);
        setSelectedLanguage(locatedSelectedLanuage[0]);
      }
      setInitLanguage(true);
    }
  }, [initLanguage, props]);

  const handleChange_SelectLanguage = (e, data) => {
    //console.debug('handleChange_SelectLanguage - e, data', {props, e, data,});
    const locatedSelectedLanuage = props.bag.contentItems.filter(navItem => navItem.value === data.value)[0];
    //console.debug('handleChange_SelectLanguage - locatedSelectedLanuage', locatedSelectedLanuage);
    if (selectedLanguage.value !== locatedSelectedLanuage.value) {
      setSelectedLanguage(locatedSelectedLanuage);
      if (locatedSelectedLanuage.value === 'fr' || locatedSelectedLanuage.value === 'es') {
        window.location.href = 'https://'+ locatedSelectedLanuage.value +'.tritondigital.com';
      } else {
        //window.location.href = window.location.host;
        window.location.href = 'https://www.tritondigital.com';
      }
    }
  }
  //console.debug('selectedLanguage', selectedLanguage);
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      {(() => {
        switch(props.pageArea) {
          case 'mobile-sidebar-nav':
            return (
              <Menu.Item key={props.id} className={'language-wrapper'}
                style={{ color: props.textColor ? props.textColor : null, }}
              >
                <p>{props.text}</p>
                {parsedProps && parsedProps.bag.contentItems.length !== 0 && selectedLanguage.value ?
                  <Dropdown className={'menu-dropdown'} aria-label={'Select Language'}
                    //simple
                    //floating
                    //defaultValue={props.navItems[0]}
                    options={parsedProps.bag.contentItems}
                    value={selectedLanguage.value}
                    onChange={handleChange_SelectLanguage}
                  />
                :
                  null
                }
              </Menu.Item>
            );
          case 'main-nav-container':
            return (
              <Menu.Item key={props.id} className={'language-wrapper'}
                style={{ color: props.textColor ? props.textColor : null, }}
              >
                <p>{props.text}</p>
                {parsedProps && parsedProps.bag.contentItems.length !== 0 && selectedLanguage.value ?
                  <Dropdown className={'menu-dropdown'} aria-label={'Select Language'}
                    //simple
                    //floating
                    //defaultValue={props.navItems[0]}
                    options={parsedProps.bag.contentItems}
                    value={selectedLanguage.value}
                    onChange={handleChange_SelectLanguage}
                  />
                :
                  null
                }
                  {/* <Dropdown.Menu>
                    {props.navItems && props.navItems.length !== 0 && props.navItems.map((navItem, i) => (
                      <Dropdown.Item key={i} as={'a'}
                        href={navItem.href.uri}
                        target={'_self'}
                      >
                        <Flag name={navItem.flag} /> {navItem.text}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown> */}
              </Menu.Item>
            );
          default:
            return null;
        }
      })()}
    </>
  )
}
